import { Checkbox, Modal, Tooltip } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import CancelPresentationIconButton from "../../common/components/Buttons/CancelPresentationIconButton";
import {
  getIndentDetailsByIndentId,
  getIndentItemsForCounterSales,
  getPatientInfoByPatientId,
  getPatientSearchAutocomplete,
} from "../PharmacyServices";
import CommonSelectableTable from "../common/CommonSelectableTable";
import CommonButton from "../../common/components/Buttons/CommonButton";
import CommonDynamicTableNew from "../../common/components/CommonTable/CommonDynamicTableNew";
import SearchDropdown from "../../common/components/FormFields/searchDropdown";
import { UseCheckConsecutiveCharacters } from "../../common/components/Custom Hooks/UseCheckConsecutiveCharacters";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import ConfirmationModal from "../../common/components/ConfirmationModal";
import { isCloseIndent } from "../../inventory/services/commonServices/StoreIndent/StoreIndentService";
import {
  errorAlert,
  successAlert,
} from "../../common/components/Toasts/CustomToasts";

const GetIndentModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  overflowY: "scroll",
  bgcolor: "background.paper",
  border: "1px solid gray",
  boxShadow: 20,
  p: 4,
};

export default function IndentModal(props) {
  const loggedUser = JSON.parse(localStorage.getItem("userInfo"));
  const [patientIndentItems, setPatientIndentItems] = React.useState("");
  const [indentId, setIndentId] = React.useState(null);
  const [storeId, setStoreId] = React.useState(null);
  const [indentDetails, setIndentDetails] = React.useState([]);
  const [selectedItems, setSelectedItems] = React.useState([]);
  const [patientOptions, setPatientOptions] = React.useState([]);
  const [indentPatientInfo, setIndentPatientInfo] = React.useState(null);
  const [isClosedIndent, setIsClosedIndent] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const { handleSubmit, reset, control, register, watch } = useForm({
    mode: "onChange",
    defaultValues: {
      searchPatient: null,
    },
  });

  let getSearchPatient = watch("searchPatient");

  // useEffect(() => {
  //   console.log("selectedItems",selectedItems);

  //   props?.handlePatientInfo(
  //     selectedItems?.PatientId,
  //     selectedItems?.AdmissionId?.length > 0 ? 1 : 0
  //   );
  // }, [selectedItems]);
  const getIndentForCounterSale = (admissionId) => {
    let searchObject = {
      admissionId: admissionId !== null ? admissionId : null,
      fromDate: new Date(),
      fromStoreId: 0,
      indentNo: "",
      indentFrom: "CounterSale",
      indentStatus: 2,
      isApproved: 2,
      isCancelled: 2,
      isForcefullyClosed: 2,
      isUrgent: 2,
      toDate: new Date(),
      toStoreId: loggedUser?.storeId,
      page: 0,
      size: 10,
    };

    getIndentItemsForCounterSales(searchObject)
      .then((response) => response.data)
      .then((res) => {
        console.log("resresres321", res);
        setPatientIndentItems(
          res?.result?.map((val) => ({
            ...val,
            indentChecked: false,
          })),
        );
      });
  };

  React.useEffect(() => {
    if (props?.open === true) {
      getIndentForCounterSale(
        props?.searchPatientVal ? props?.admissionId : null,
      );
    }
  }, [props.open]);

  console.log("patientIndentItems", patientIndentItems);

  // React.useEffect(() => {
  //   if (indentId !== null && storeId !== null) {
  //     getIndentDetailsByIndentId(storeId, indentId)
  //       .then((response) => response.data)
  //       .then((res) => {
  //         if (res.result?.length > 0) {
  //           let items = [];
  //           for (let indentObject of res.result) {
  //             indentObject.isChecked = true;
  //             items.push(indentObject);
  //             setSelectedItems(items);
  //           }
  //           let dataObject = { result: items };
  //           setIndentDetails(dataObject);
  //         }
  //       });
  //   }
  // }, [indentId, storeId]);

  console.log("selectedItems", selectedItems);

  const handleGetIndentItems = () => {
    if (selectedItems?.length > 0) {
      let prescriptions = [];
      for (let object of selectedItems?.filter((val) => val?.Select === true)) {
        let prescriptionObject = {
          id: object?.Id,
          bins: object?.Bins,
          code: object?.Code,
          pharmacyItem: object?.Drug,
          BatchesRequired: object?.BatchesRequired,
          batchNo: "",
          balanceQuantity: object?.BalanceQty,
          IndentQty: object?.IndentQty,
          PendIssueQty: object?.PendIssueQty,
          expiryDate: "",
          mrp: 0,
          sgstPercentage: 0,
          cgstPercentage: 0,
          rackName: object?.Rack,
          shelfName: object?.Shelf,
          rack: {
            id: object,
          },
          shelf: {
            id: object,
          },
          purchaseRate: 0,
          landedRate: 0,
          quantity: Number(object?.IndentQty),
          amount: 0,
          discountPercentage: 0,
          discountAmount: 0,
          netAmount: 0,
          mrpExcludeGst: 0,
          cgstAmount: "",
          sgstAmount: "",
          taxableAmount: 0,
          prescribeQuantity: 0,
          saleQuantity: Number(object?.IndentQty),
          itemMaster: {
            id: object?.Id,
          },
          genericId: object?.ItemGenericId,
          gstPercent: object?.VATPercentage,
          gstAmount: 0,
          conversion: object?.Conversion,
          IsConsignment: object?.IsConsignment,
          IndentDetailId: object?.IndentDetailId,
          IndentId: object?.IndentId,
        };
        prescriptions.push(prescriptionObject);
        props.setData(prescriptions);
      }
    }
    props.setResetIndentCount(props.resetIndentCount + 1);
    props.close();
    setPatientIndentItems([]);
    setSelectedItems([]);
    setIndentId(null);
  };

  const CloseIndent = () => {
    let obj = {
      indentId: selectedRow.IndentId,
      menuId: props?.menuId,
      privilege: props?.privilege,
    };

    isCloseIndent(obj)
      .then((response) => response.data)
      .then((res) => {
        successAlert(res.message);
        getIndentForCounterSale(
          props?.searchPatientVal ? props?.admissionId : null,
        );
        setIsClosedIndent(false);
        setSelectedRow(null);
        props.setPrivilege("");
        setSelectedItems([]);
      })
      .catch((error) => {
        errorAlert(error?.data?.result?.message || error.message);
        setIsClosedIndent(false);
      });
  };

  const renderIndentActions = (row, index) => {
    return (
      <div className="flex space-x-1 items-center">
        <fieldset className="-my-1">
          <Checkbox
            checked={row?.indentChecked}
            size="small"
            disabled={patientIndentItems?.some(
              (val) =>
                val?.indentChecked === true &&
                val?.PatientId !== row?.PatientId,
            )}
            onChange={(e) => {
              let indentArray = [...patientIndentItems];
              if (e?.target?.checked === true) {
                indentArray[index].indentChecked = true;
                getIndentDetailsByIndentId(row?.ToStoreId, row?.IndentId).then(
                  (response) => {
                    setSelectedItems([
                      ...selectedItems,
                      ...response?.data?.result?.map((val) => ({
                        Select: true,
                        IndentId: row?.IndentId,
                        ...val,
                      })),
                    ]);
                  },
                );
                getPatientInfoById(row?.PatientId);
              } else if (e?.target?.checked === false) {
                indentArray[index].indentChecked = false;
                let indentItemsArray = selectedItems?.filter(
                  (val) => val?.IndentId !== row?.IndentId,
                );
                setSelectedItems(indentItemsArray);
                setIndentPatientInfo(null);
              }
              setPatientIndentItems(indentArray);
            }}
          />
        </fieldset>
        {props?.userActions?.map((actions) => (
          <>
            {actions.action === "Close Indent" && actions?.isAction === true ? (
              <>
                {row.Closed === false ? (
                  <div className="flex items-center space-x-1">
                    <Tooltip title="Close Indent">
                      <button
                        type="button"
                        className="text-red-600 "
                        onClick={() => {
                          setIsClosedIndent(true);
                          setSelectedRow(row);
                          props.setPrivilege(actions.action);
                        }}
                      >
                        <HighlightOffIcon />
                      </button>
                    </Tooltip>
                  </div>
                ) : (
                  <span>
                    <HighlightOffIcon className="text-gray-100" />
                  </span>
                )}
              </>
            ) : null}
          </>
        ))}
      </div>
    );
  };

  const renderInput = (row, index, header) => {
    return (
      <>
        {header === "Select" && (
          <fieldset className="-my-2">
            <Checkbox
              checked={row?.Select}
              size="small"
              onChange={(e) => {
                let indentItemsArray = [...selectedItems];
                if (e?.target?.checked === true) {
                  indentItemsArray[index].Select = true;
                } else if (e?.target?.checked === false) {
                  indentItemsArray[index].Select = false;
                }
                setSelectedItems(indentItemsArray);
              }}
            />
          </fieldset>
        )}
      </>
    );
  };

  const rowBackgroundColor = (row) => {
    if (row.IsUrgent) {
      return "#f87171";
    } else if (row.isPmcPatient) {
      return "#83b4e6";
    } else if (row.isPpnPatient) {
      return "#93face";
    } else if (row.isCorporatePatient) {
      return "#f5a6b9";
    } else if (row.isTpaPatient) {
      return "#f8d09c";
    } else if (row.highAnti) {
      return "#10b981";
    }
  };

  const handleChange = (autoSearchString) => {
    if (
      autoSearchString !== "" &&
      UseCheckConsecutiveCharacters(autoSearchString)
    ) {
      getPatientSearchAutocomplete(autoSearchString, 1)
        .then((response) => response.data)
        .then((res) => {
          setPatientOptions(res.result);
        });
    }
  };

  const getPatientInfoById = (patientId) => {
    getPatientInfoByPatientId(patientId, 1, props?.loginObj?.storeId)
      .then((response) => response.data)
      .then((res) => {
        setIndentPatientInfo(res.result);
      })
      .catch((error) => {
        setIndentPatientInfo(null);
      });
  };

  return (
    <div className="mt-10">
      <Modal
        open={props.open}
        onClose={props.close}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={GetIndentModalStyle} className="max-h-[88%] xl:max-h-[80%]">
          <div className="grid grid-cols-1 md:grid-cols-1  w-full ">
            <CancelPresentationIconButton
              onClick={() => {
                props.close();
                setPatientIndentItems([]);
                setSelectedItems([]);
                setIndentPatientInfo(null);
                setPatientOptions([]);
              }}
            />
            <div className="row">
              <div className="grid grid-cols-3">
                <div className="flex space-x-5 col-span-2">
                  <div className=" text-xl font-semibold my-2">Get Indent</div>
                  <div className="w-80 xl:w-96">
                    <SearchDropdown
                      control={control}
                      name="searchPatient"
                      dataArray={patientOptions}
                      searchIcon={true}
                      isClearable={true}
                      isSearchable={true}
                      placeholder="Search By Patient Name/Indent No."
                      handleInputChange={handleChange}
                      isDisabled={
                        props?.searchPatientVal !== null &&
                        props?.searchPatientVal !== undefined
                      }
                      inputRef={{
                        ...register("searchPatient", {
                          onChange: (e) => {
                            setSelectedItems([]);
                            if (e?.target?.value !== null) {
                              getPatientInfoByPatientId(
                                e?.target?.value?.id,
                                1,
                                props?.loginObj?.storeId,
                              )
                                .then((response) => response.data)
                                .then((res) => {
                                  setIndentPatientInfo(res.result);
                                  getIndentForCounterSale(
                                    res?.result?.AdmissionId,
                                  );
                                })
                                .catch((error) => {
                                  setIndentPatientInfo(null);
                                });
                            } else {
                              setIndentPatientInfo(null);
                            }
                          },
                        }),
                      }}
                    />
                  </div>
                </div>
                <div className="flex justify-end whitespace-nowrap gap-5 items-center">
                  <div className="h-5 w-5 bg-[#f5a6b9] -mr-2 rounded"></div>
                  <div className="">Corporate</div>
                  <div className="h-5 w-5 bg-[#f8d09c] -mr-2 rounded"></div>
                  <div>TPA</div>
                  <div className="h-5 w-5 bg-[#83b4e6] -mr-2 rounded"></div>
                  <div>PMC</div>
                  <div className="h-5 w-5 bg-[#93face] -mr-2 rounded"></div>
                  <div>PPN</div>
                  <div className="text-sm flex justify-end whitespace-nowrap">
                    <span
                      style={{
                        backgroundColor: "#10b981",
                        height: "20px",
                        width: "20px",
                        display: "inline-block",
                        marginRight: "8px",
                        borderRadius: "4px",
                      }}
                    ></span>
                    Higher Antibiotics
                  </div>
                </div>
              </div>
              <div className="p-2 grid grid-cols-2 lg:grid-cols-5 gap-2 border border-gray-400 rounded-xl bg-[#F1F1F1]">
                <div className="flex gap-2 items-center lg:col-span-2">
                  <h1 className="font-semibold text-sm text-black">
                    Patient Name
                  </h1>
                  <div className="flex space-x-2 items-center">
                    <span>:</span>
                    <span className="text-black font-normal">
                      {props?.patientInfo?.patientName ||
                        indentPatientInfo?.patientName}
                    </span>
                  </div>
                </div>

                <div className="flex gap-2 space-x-8 xl:space-x-3 items-center">
                  <h1 className="font-semibold text-sm text-black">MRNo.</h1>
                  <div className="flex space-x-2 items-center">
                    <span>:</span>
                    <span className="text-black font-normal">
                      {props?.patientInfo?.mrNo || indentPatientInfo?.mrNo}
                    </span>
                  </div>
                </div>
                <div className="flex gap-2 space-x-3 lg:space-x-11 items-center">
                  <h1 className="font-semibold text-sm text-black">Age</h1>
                  <div className="flex space-x-2 items-center">
                    <span>:</span>
                    <span className="text-black font-normal">
                      {props?.patientInfo?.AgeYear ||
                        indentPatientInfo?.AgeYear}
                    </span>
                  </div>
                </div>
                <div className="flex gap-2 space-x-5 xl:space-x-1 items-center">
                  <h1 className="font-semibold text-sm text-black">
                    Mobile No.
                  </h1>
                  <div className="flex space-x-2 items-center">
                    <span>:</span>
                    <span className="text-black font-normal">
                      {props?.patientInfo?.MobileNo ||
                        indentPatientInfo?.MobileNo}
                    </span>
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-2 my-2">
                {patientIndentItems?.length > 0 ? (
                  <div>
                    {/* <CommonSelectableTable
                      data={patientIndentItems}
                      setIndentId={setIndentId}
                      setStoreId={setStoreId}
                      component="main"
                      handlePatientInfo={props?.handlePatientInfo}
                    /> */}
                    <CommonDynamicTableNew
                      dataResult={patientIndentItems}
                      renderActions={renderIndentActions}
                      rowBackgroundColor={rowBackgroundColor}
                      tableClass={"rounded h-60 xl:h-96"}
                      highlightRow={false}
                      removeHeaders={[
                        "Id",
                        "DrId",
                        "IsUrgent",
                        "Remark",
                        "Closed",
                        "ClosedOnIssue",
                        "IsCancelled",
                        "IsForcefullyClosed",
                        "IsApproved",
                        "IsApproved",
                        "isprinted",
                        "PatientId",
                        "Cash_Credit",
                        "indentChecked",
                      ]}
                    />
                  </div>
                ) : (
                  <div className="h-60 xl:h-96 flex justify-center items-center font-semibold border rounded mt-2">
                    No Indents Found...
                  </div>
                )}
                {selectedItems?.length > 0 ? (
                  <div>
                    <CommonDynamicTableNew
                      dataResult={selectedItems}
                      renderInput={renderInput}
                      rowBackgroundColor={rowBackgroundColor}
                      editableColumns={["Select"]}
                      highlightRow={false}
                      tableClass={"rounded h-60 xl:h-96"}
                      removeHeaders={[
                        "Id",
                        "DrId",
                        "IsUrgent",
                        "Remark",
                        "Closed",
                        "ClosedOnIssue",
                        "IsCancelled",
                        "IsForcefullyClosed",
                        "IsApproved",
                        "IsApproved",
                        "isprinted",
                        "PatientId",
                        "Cash_Credit",
                        "IndentId",
                      ]}
                    />
                    {/* <CommonSelectableTable
                      data={indentDetails}
                      setData={setIndentDetails}
                      selectedItems={selectedItems}
                      setSelectedItems={setSelectedItems}
                      component="child"
                    /> */}
                  </div>
                ) : (
                  <div className="h-60 xl:h-96 flex justify-center items-center font-semibold border rounded">
                    No Indent Items Found...
                  </div>
                )}
              </div>
              <div className="flex justify-end my-2">
                {selectedItems?.length > 0 && (
                  <CommonButton
                    label="Get Items"
                    className="bg-[#16A34A] text-white px-2 h-9 rounded"
                    type="button"
                    onClick={() => {
                      props?.setPatientInfo(indentPatientInfo);
                      handleGetIndentItems();
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        </Box>
      </Modal>
      <ConfirmationModal
        confirmationOpen={isClosedIndent}
        confirmationHandleClose={() => {
          setIsClosedIndent(false);
          props.setPrivilege("");
        }}
        confirmationSubmitFunc={CloseIndent}
        confirmationLabel="Confirmation"
        confirmationMsg="Are you sure want to close this indent ?"
        confirmationButtonMsg="Yes"
      />
    </div>
  );
}
